import {
  useGroup
} from "./2NIRKFVH.js";
import {
  createComponent,
  createElement,
  createHook
} from "./NQJBHION.js";
import {
  __objRest
} from "./PNRLI7OV.js";

// src/form/form-group.ts
var useFormGroup = createHook(
  (_a) => {
    var _b = _a, { store } = _b, props = __objRest(_b, ["store"]);
    props = useGroup(props);
    return props;
  }
);
var FormGroup = createComponent((props) => {
  const htmlProps = useFormGroup(props);
  return createElement("div", htmlProps);
});
if (process.env.NODE_ENV !== "production") {
  FormGroup.displayName = "FormGroup";
}

export {
  useFormGroup,
  FormGroup
};
